import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import uniqBy from 'lodash.uniqby';

import { IdentityForJerseyColors } from '../graphql/queries/identity';

const useIdentityJerseyColors = ({ identityId, albumFolderId }) => {
  const { data: { identity } = {}, loading } = useQuery(
    IdentityForJerseyColors,
    {
      variables: {
        id: identityId,
        album_folder_id: albumFolderId,
      },
      skip: !identityId || !albumFolderId,
      fetchPolicy: 'cache-first',
    },
  );
  const teamName = useMemo(() => {
    const tagRecords = identity?.album_folder_tags?.records ?? [];
    const teams = tagRecords
      .map(tag => tag.uniform_album_folder_tag_level_team)
      .filter(Boolean);

    return teams?.[0]?.name ?? '';
  }, [identity]);

  const levelName = useMemo(() => {
    const tagRecords = identity?.album_folder_tags?.records ?? [];
    const levels = tagRecords
      .map(tag => tag.uniform_album_folder_tag_level)
      .filter(Boolean);

    return levels?.[0]?.name ?? '';
  }, [identity]);

  const jerseyColors = useMemo(() => {
    // Uniform Color related
    const tagRecords = identity?.album_folder_tags?.records ?? [];
    const teams = tagRecords
      .map(tag => tag.uniform_album_folder_tag_level_team)
      .filter(Boolean);
    const teamsJerseysColors = teams.map(team =>
      (team?.jerseys?.records ?? [])
        ?.filter(({ name }) => name !== 'White (Default)')
        .map(({ colors }) => colors),
    );

    const uniformJerseyColors = teamsJerseysColors.reduce(
      (acc, teamJerseysColors) => {
        teamJerseysColors.forEach(colors => {
          colors.forEach(color => {
            if (!acc.includes(color.toUpperCase())) {
              acc.push(color.toUpperCase());
            }
          });
        });

        return acc;
      },
      [],
    );

    // Hierarchy Jersey Color related
    const hierarchyJerseyColors = (
      identity?.hierarchy_jersey_colors?.records ?? []
    ).map(({ jersey_color: color }) => color);

    return uniqBy([...uniformJerseyColors, ...hierarchyJerseyColors]);
  }, [identityId, albumFolderId, identity]);

  return {
    teamName,
    levelName,
    jerseyColors,
    loadingJerseyColors: loading,
  };
};

export default useIdentityJerseyColors;
